module.exports = __webpack_public_path__ + "img/why-us-card-img-4.816f1b43.jpg";